// The account requests index.html starts while this bundle downloads: /me on
// every page, and /rpc and /rpc/keys on the account pages, so a signed-in
// load waits for one round trip to willow-saas instead of two in a row.
//
// Each response is handed out once, to the first caller; later calls fetch
// again. If /me fails, the others are dropped unread, so a sign-in that
// follows never sees a 401 that was fetched without a session.

import { readSaas } from './saas-client';

type BootKey = 'me' | 'rpc' | 'keys';

declare global {
  interface Window {
    __willowBoot?: Partial<Record<BootKey, Promise<Response>>>;
  }
}

/** The response index.html fetched for `key`, read like `saasCall`, or null:
 *  never fetched, or already taken. */
export function takeBoot<T>(key: BootKey): Promise<T> | null {
  const boot = window.__willowBoot;
  const res = boot?.[key];
  if (!boot || !res) return null;
  delete boot[key];
  return res.then((r) => readSaas<T>(r));
}

/** Forget every response not taken yet. */
export function dropBoot(): void {
  window.__willowBoot = undefined;
}
